import React from 'react'
import css from './NotFound.module.scss'
import lCss from '../../Layout/Layout.module.scss'

const NotFound = () => {
	return (
		<>
			<div className={lCss.content}>
				<div className={css.block}>
					<div className={css.table}>
						<div className={css.title404}>404</div>
						<div className={css.title}>Страница не найдена</div>
					</div>
				</div>
			</div>
			<div className={lCss.sidebar}/>
		</>
	)

}

export default NotFound